import { render } from "./TetrisGame.vue?vue&type=template&id=6780536a&scoped=true&ts=true"
import script from "./TetrisGame.vue?vue&type=script&lang=ts"
export * from "./TetrisGame.vue?vue&type=script&lang=ts"

import "./TetrisGame.vue?vue&type=style&index=0&id=6780536a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6780536a"]])

export default __exports__